import { render } from "./PurchaseInvoiceUpload.vue?vue&type=template&id=2a3ede4a&scoped=true"
import script from "./PurchaseInvoiceUpload.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceUpload.vue?vue&type=script&lang=js"

import "./PurchaseInvoiceUpload.vue?vue&type=style&index=0&id=2a3ede4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3ede4a"]])

export default __exports__